import type { ProjectDetail } from "@/mocks/admin/projects";

type Props = { timeline: ProjectDetail["timeline"]; notes: string };

export default function Timeline({ timeline, notes }: Props) {
  return (
    <div className="bg-white border border-ink-100 rounded-lg p-5">
      <h3 className="font-display text-base font-bold text-ink-900 mb-1">Activity Timeline</h3>
      <p className="text-[11px] text-ink-500 mb-5">From booking confirmation to completion</p>

      <ol className="relative space-y-5">
        <div className="absolute left-[15px] top-2 bottom-2 w-px bg-ink-100"></div>
        {timeline.map((t) => (
          <li key={t.id} className="relative flex items-start gap-3">
            <div
              className={`relative z-10 w-8 h-8 rounded-full ${t.iconBg} ${t.iconColor} flex items-center justify-center ring-4 ring-white shrink-0`}
            >
              <i className={`${t.icon} text-sm`}></i>
            </div>
            <div className="flex-1 min-w-0 pt-1">
              <div className="flex items-baseline gap-2 flex-wrap">
                <span className="text-sm font-semibold text-ink-900">{t.title}</span>
                <span className="text-[11px] text-ink-400">{t.time}</span>
              </div>
              <div className="text-xs text-ink-500 mt-0.5">{t.detail}</div>
            </div>
          </li>
        ))}
      </ol>

      <div className="mt-6 pt-5 border-t border-ink-100">
        <div className="text-[10px] font-bold uppercase tracking-wider text-ink-400 mb-2">
          Internal notes
        </div>
        <div className="text-sm text-ink-700 bg-cream-50 border border-ink-100 rounded-md p-3 leading-relaxed">
          {notes}
        </div>
      </div>
    </div>
  );
}